<template>
	<v-menu v-model="menu" bottom left offset-y origin="top right" transition="scale-transition" :close-on-content-click="false">
		<template v-slot:activator="{ attrs, on }">
			<v-btn class="mx-2" @click="menu = true" fab v-bind="attrs" v-on="on" small elevation="0" height="30" width="30">
				<!-- <v-btn class="ml-2" @click="menu=true" min-width="0" text v-bind="attrs" v-on="on"> -->
				<v-icon color="#333">mdi-magnify</v-icon>
			</v-btn>
		</template>
		<div class="px-0 d-flex justify-center">
			<v-tabs v-model="activeTab" background-color="#ddd" centered color="secondary" slider-color="secondary">
				<v-tab :key="0">جستجوی مشتری</v-tab>
				<v-tab :key="1">جستجوی وام</v-tab>

				<v-tabs-items v-model="activeTab" touchless>
					<v-tab-item :key="0">
						<v-form @submit.prevent="search" class="px-2">
							<v-text-field v-model="member.searchText" placeholder="جستجوی مشتری" class="" color="secondary" hide-details style="max-width: 320px">
								<template v-slot:append-outer>
									<v-btn class="mt-n2 mr-n2" type="submit" :loading="loading" fab small elevation="2" height="34" width="34">
										<v-icon>mdi-magnify</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-form>
						<v-list flat nav style="max-height: 500px;overflow-y: auto;">
							<v-list-item-group v-model="member.selectedItem" color="primary">
								<v-list-item v-if="member.message">
									<v-list-item-content>
										<v-list-item-title>{{ member.message }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item selectable v-else v-for="(member) in member.items" :key="member.id" link :value="member" @click="() => { menu = false; routeToMemberProfile(member.id) }">
									<v-list-item-content>
										<v-list-item-title style="line-height: 2;"><span>نام مشتری:</span> <span class="grey--text"><b>{{ member.fullName }}</b></span> <span>کد ملی:</span> <span class="grey--text"><b>{{ member.nationalCode }}</b></span> <span>موبایل:</span> <span class="grey--text"><b>{{ member.mobile }}</b></span></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-tab-item>
					<v-tab-item :key="1">
						<v-form @submit.prevent="searchLoan" class="px-2">
							<v-text-field v-model="loan.searchText" placeholder="شماره وام" class="" color="secondary" hide-details style="max-width: 320px">
								<template v-slot:append-outer>
									<v-btn class="mt-n2 mr-n2" type="submit" :loading="loading" fab small elevation="2" height="34" width="34">
										<v-icon>mdi-magnify</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</v-form>
						<v-list flat nav style="max-height: 500px;overflow-y: auto;">
							<v-list-item-group v-model="loan.selectedItem" color="primary">
								<v-list-item v-if="loan.message">
									<v-list-item-content>
										<v-list-item-title>{{ loan.message }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item selectable v-else v-for="(loan) in loan.items" :key="loan.id" link :value="loan" @click="() => { menu = false; routeToMemberProfile(loan.userId) }">
									<v-list-item-content>
										<v-list-item-title style="line-height: 2;"><span>عنوان وام:</span> <span class="grey--text"><b>{{ loan.title }}</b></span> <span>شماره وام:</span> <span class="grey--text"><b>{{ loan.code }}</b></span><span>مشتری:</span> <span class="grey--text"><b>{{ loan.fullName }}</b></span> <span>کد ملی:</span> <span class="grey--text"><b>{{ loan.nationalCode }}</b></span></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</div>


	</v-menu>

</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'

export default {
	name: 'DefaultSearch',
	data: () => ({
		activeTab: 0,
		loading: false,
		member: {
			message: '',
			searchText: '',
			previousSearch: '',
			items: [],
			selectedItemIndex: -1,
			selectedItem: null
		},
		loan: {
			message: '',
			searchText: '',
			previousSearch: '',
			items: [],
			selectedItemIndex: -1,
			selectedItem: null
		},
		menu: false,
	}),
	mounted() {
		document.addEventListener("keyup", this.nextItem)
	},
	methods: {
		nextItem(event) {
			if (this.activeTab == 0) {
				if (event.keyCode == 38 && this.member.selectedItemIndex > 0) {
					this.member.selectedItem = this.member.items[--this.member.selectedItemIndex]
				} else if (event.keyCode == 40 && this.member.selectedItemIndex < this.member.items.length - 1) {
					this.member.selectedItem = this.member.items[++this.member.selectedItemIndex]
				}
			}
			else if (this.activeTab == 1) {
				if (event.keyCode == 38 && this.loan.selectedItemIndex > 0) {
					this.loan.selectedItem = this.loan.items[--this.loan.selectedItemIndex]
				} else if (event.keyCode == 40 && this.loan.selectedItemIndex < this.loan.items.length - 1) {
					this.loan.selectedItem = this.loan.items[++this.loan.selectedItemIndex]
				}
			}
		},
		search() {
			if (this.member.previousSearch == this.member.searchText && this.member.selectedItem) {
				this.menu = true
				this.routeToMemberProfile(this.member.selectedItem.id)
				return
			}
			this.member.previousSearch = this.member.searchText
			if (!this.member.searchText.length) {
				this.member.message = 'ورود شماره وام الزامی است'
				return
			}

			// this.menu = false
			this.loading = true
			this.member.message = ''
			api.get('admin/member/search/' + this.member.searchText, null)
				.then(
					response => {
						this.member.items = response
						this.member.message = this.member.items.length === 0 ? 'موردی یافت نشد.' : ''
						this.member.selectedItemIndex = this.member.items.length ? 0 : -1
						this.member.selectedItem = this.member.selectedItemIndex > -1 ? this.member.items[this.member.selectedItemIndex] : null
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.menu = true
					this.loading = false
				})
		},
		searchLoan() {
			if (this.loan.previousSearch == this.loan.searchText && this.loan.selectedItem) {
				this.menu = true
				this.routeToMemberProfile(this.loan.selectedItem.id)
				return
			}
			this.loan.previousSearch = this.loan.searchText
			if (!this.loan.searchText || this.loan.searchText.length < 3) {
				this.loan.message = 'ورود حداقل 3 کاراکتر الزامی است'
				return
			}

			// this.menu = false
			this.loading = true
			this.loan.message = ''
			api.get('admin/userLoan/search/' + this.loan.searchText, null)
				.then(
					response => {
						this.loan.items = response
						this.loan.message = this.loan.items.length === 0 ? 'موردی یافت نشد.' : ''
						this.loan.selectedItemIndex = this.loan.items.length ? 0 : -1
						this.loan.selectedItem = this.loan.selectedItemIndex > -1 ? this.loan.items[this.loan.selectedItemIndex] : null
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.menu = true
					this.loading = false
				})
		},
		routeToMemberProfile(memberId) {
			this.$router.replace({ name: 'admin/MemberProfile', params: { memberId: memberId } }).catch(() => { })
		}
	},
}
</script>
